import AccessControl from "./AccessControl";

import "./AccessControl.scss";

export default AccessControl;